import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getItem, GET_INFO } from 'utils/sessionStorage';
import UserMenu from './UserMenu';

const UserStatus = () => {
  const navigate = useNavigate();
  const userInfo = getItem(GET_INFO);
  return (
    <div className="user-status">
      {userInfo ? (
        <UserMenu />
      ) : (
        <div className="join">
          <button onClick={() => navigate('/connect')} className="login padding-row-12 padding-col-8 border-none border-radius-10 background-primary white background-primary-hover link">
            CONNECT
          </button>
        </div>
      )}
    </div>
  );
};

export default UserStatus;
